import React, { useEffect } from 'react';
import { connect } from 'react-redux';

export default (ChildComponent) => {
  const ComposedComponent = (props) => {
    useEffect(() => {
      if (!props.auth) {
        props.history.push('/signin');
      }
    }, [props.auth, props.history]);

    return <ChildComponent {...props} />;
  };

  function mapStateToProps(state) {
    return { auth: state.auth.authenticated };
  }

  return connect(mapStateToProps)(ComposedComponent);
};
